import axios from "axios"


/**
 *
 * @status no delete
 * @class UserService
 */
class UserService {
  constructor(apiUrl) {
    this.apiUrl = apiUrl
  }

  /**
   * @author Leonel Contreras
   * @description Handle event to get the user information from auth0
   * @date 20-07-2020
   * @status no delete
   * @param {Object} auth0Id
   * @param {String} token
   * @returns {Object}
   * @memberof UserService
   */
  async getUser(auth0Id, token) {
    let mail = localStorage.getItem('token')
    mail = JSON.parse(mail)
    mail = mail.user?.internalData?.email
    let response = await axios.get(`${this.apiUrl}/user-auth-passthrough?auth0Id=${auth0Id}&email=${mail}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
    return response.data.data
  }

  /**
  * @author Leonel Contreras
  * @description Handle event to get the user information from auth0
  * @date 20-07-2020
  * @status no delete
  * @param {Object} auth0Id
  * @param {String} token
  * @returns {Object}
  * @memberof UserService
  */
  async getUserEmailVerificationStatus(email) {
    let response = await axios.get(`${this.apiUrl}/user-email-verification-status-passthrough?email=${email}`)
    return response.data.data
  }

  /**
   * @author Alan Aguilar
   * @description Handle event to update the user information in A3cloud and hibou.legal
   * @date 05-10-2020
   * @status no delete
   * @param {Object} user
   * @param {String} token
   * @returns {Object}
   * @memberof UserService
   */
  async updateUser(user, token) {
    let response = await axios.put(`${this.apiUrl}/user`, user, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })

    return response.data
  }

  /**
   * @author Juan Manuel Lamperti
   * @description Get collaborators
   * @updatedDate 23-06-2022
   * @status no delete
   * @param {String} token
   * @returns {Object}
   * @memberof UserService
   */
  async getUsersCollaboratorAdmin(token) {
    let response = await axios.get(`${this.apiUrl}/users-collaborator-admin-passthrough`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })

    return response.data.data
  }

  /**
   * @author Jorge Perales
   * @description Obtiene el catálogo de usuarios (colaboradores) de un cliente, para el filtro de usuario en historial
   * @date 30/07/2026
   * @param {String} clientId
   * @param {String} token
   * @returns {Object}
   * @memberof UserService
   */
  async getUsersCollaboratorByClientId(clientId, token) {
    let response = await axios.get(`${this.apiUrl}/users-collaborator-by-clientId-passthrough?clientId=${clientId}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })

    return response.data.data
  }

  /**
   * @author Juan Manuel Lamperti
   * @description Get roles signature profile for users
   * @updatedDate 8-7-2022
   * @status no delete
   * @param {String} token
   * @returns {Object}
   * @memberof UserService
   */

  async getRolesAssignView(token) {
    let response = await axios.get(`${this.apiUrl}/roles-assign-view-passthrough`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })

    return response.data.data
  }

  /**
   * @author Juan Manuel Lamperti
   * @description Get roles for user by email
   * @updatedDate 11-7-2022
   * @status no delete
   * @param {String} token
   * @returns {Object}
   * @memberof UserService
   */
  async getRolesForUserByEmail(token, email) {
    email = email.toLowerCase()

    let response = await axios.get(
      `${this.apiUrl}/roles-user-by-email-passthrough?email=${email}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    )

    return response.data
  }

  /**
   * @author Juan Manuel Lamperti
   * @updatedBy Mario Carrizales 23-06-2023
   * @description Creates a new user collaborator
   * @updatedDate 14-7-2022
   * @status no delete
   * @param {String} token
   * @param {userData} body
   * @returns {Object}
   * @memberof UserService
   */
  async createNewUserCollaborator(token, email) {
    const userData = {
      email: email.toLowerCase()
    }

    let response = await axios.post(
      `${this.apiUrl}/create-new-user-invited-passthrough`,
      userData,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    )
    return response.data
  }

  /**
   * @author Juan Manuel Lamperti
   * @description Update user status
   * @updatedDate 14-7-2022
   * @status no delete
   * @param {String} token
   * @param {userProfileData} body
   * @returns {Object}
   * @memberof UserService
   */

  async updateUserStatus(token, userStatus) {
    let response = await axios.put(
      `${this.apiUrl}/update-user-status`,
      userStatus,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    )
    return response.data
  }

  /**
   * @author Junaid Khan
   * @description Update user email verification status
   * @updatedDate 22-04-2024
   * @status no delete
   * @param {userProfileData} body
   * @returns {Object}
   * @memberof UserService
   */

  async updateUserEmailVerificationStatus(email) {
    let response = await axios.put(
      `${this.apiUrl}/user-email-verification-status-passthrough`,
      {
        email
      },
    )
    return response.data
  }

  /**
* @author Junaid Khan
* @description update the user profile picture 
* @date 25-04-2024
* @status no delete
* @param {String} token
* @param {Object} img
* @returns {Object}
* @memberof ClientService
*/
  async updateUserProfileImage(token, data) {
    let response = await axios.put(`${this.apiUrl}/user-profile-image-passthrough`, data, {
      headers: {
        'Authorization': `Bearer ${token}`
      }
    })
    return response.data
  }


  /**
  * @author Junaid Khan
  * @description traer imagen del cliente al back-end
  * @date 02-06-2021
  * @status no delete
  * @param {String} token
  * @param {Object} img
  * @returns {Object}
  * @memberof ClientService
  */
  async getUserProfileImage(token) {
    let response = await axios.get(`${this.apiUrl}/client-image-passthrough`, {
      headers: {
        'Authorization': `Bearer ${token}`
      }
    })
    return response.data
  }


  /**
   * @author Juan Manuel Lamperti
   * @description Get current roles companies
   * @updatedDate 18-7-2022
   * @status no delete
   * @param {String} token
   * @param {userEmail} body
   * @returns {Object}
   * @memberof UserService
   */
  async getUserRolesCompany(token, userEmail, timezone) {
    userEmail = userEmail.toLowerCase()
    let response = await axios.get(
      `${this.apiUrl}/user-roles-company?email=${userEmail}&timezone=${timezone}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    )
    return response.data
  }

  /**
   * @author Juan Manuel Lamperti
   * @description Save roles for user company
   * @updatedDate 18-7-2022
   * @status no delete
   * @param {String} token
   * @param {userComapanies} body
   * @returns {Object}
   * @memberof UserService
   */

  async saveRolesForUserByCompany(token, userComapanies) {
    let response = await axios.post(
      `${this.apiUrl}/company-roles-for-user`,
      userComapanies,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    )
    return response.data
  }

  /**
   * @author Adriana Fdz
   * @description update user roles
   * @param {*} token
   * @param {*} data
   * @return {*} 
   * @memberof UserService
   */
  async updateUserRoles(token, data) {
    let response = await axios.put(`${this.apiUrl}/user-role-passthrough`, data, {
      headers: {
        'Authorization': `Bearer ${token}`
      }
    })
    return response.data
  }

  /**
   * @author Jorge Perales
   * @description update user permissions
   * @updatedDate 17-12-2025
   * @param {*} token
   * @param {*} data
   * @return {*}
   * @memberof UserService
   */
  async updateUserPermissions(token, data) {
    let response = await axios.put(`${this.apiUrl}/user-permissions-passthrough`, data, {
      headers: {
        'Authorization': `Bearer ${token}`
      }
    })
    return response.data
  }

  /**
   * @author Brayan Salas
   * @description Method to update phone number
   * @param {*} phoneNumber
   * @param {*} token
   * @return {*} 
   * @memberof UserService
   */
  async updatePhoneNumber(phoneNumber, token) {
    let response = await axios.put(`${this.apiUrl}/phone-number-passthrough`, { phoneNumber }, {
      headers: {
        'Authorization': `Bearer ${token}`
      }
    })
    return response.data
  }

  /**
   * @author Adriana Fernandez
   * @description Method to update language
   * @param {*} language
   * @param {*} token
   * @return {*} 
   * @memberof UserService
   */
  async updateLanguage(lng, token) {
    let response = await axios.put(`${this.apiUrl}/language`, { lng }, {
      headers: {
        'Authorization': `Bearer ${token}`
      }
    })
    return response.data
  }

   /**
   * @author Antonio Vazquez
   * @description get assistants
   * @date 10-11-2025
   * @returns {Object}
   * @memberof UserService
   */
  async getAssistants(clientId, token) {
    try {
      let response = await axios.get(
        `${this.apiUrl}/get-all-bot-configs?clientId=${clientId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`
          }
        }
      )

      if (response.data.statusCode !== 200) {
          throw new Error(response.data.message)
      }

      return response.data?.data
    } catch(e) {
      console.error(`An error occurred in getAssistants: ${e}`)
    }
  }

  /**
   * @author Jorge Perales
   * @description Obtener catálogo de plantillas de asistentes
   * @date 21-07-2026
   * @returns {Object}
   * @memberof UserService
   */
  async getBotTemplates(token) {
    try {
      const response = await axios.get(
        `${this.apiUrl}/bot-templates`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          }
        }
      )

      const body = response.data

      if (!Array.isArray(body) && body?.statusCode && body.statusCode !== 200) {
        throw new Error(body.message)
      }

      // Tolerate the array coming unwrapped, under `data`, or under `rows`,
      // and items still carrying Sequelize's `dataValues` wrapper.
      const rawList = Array.isArray(body) ? body : (body?.data ?? body?.rows ?? [])

      return rawList.map((item) => {
        const values = item?.dataValues || item
        return {
          id: values.id,
          templateKey: values.templateKey,
          name: values.name,
          description: values.description,
          config: values.config
        }
      })
    } catch (e) {
      console.error(`An error occurred in getBotTemplates: ${e}`)
      throw e
    }
  }

   /**
   * @author Antonio Vazquez
   * @description event to create new assistant
   * @date 11-11-2025
   * @returns {Object}
   * @memberof UserService
   */
  async postCreateNewAssistant(clientId, chatbotName, templateId, token) {
    try {
      const body = {
        chatbotName,
        templateId
      }
      let response = await axios.post(
        `${this.apiUrl}/create-bot-config?clientId=${clientId}`,
        body,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          }
        }
      )

      if (response.data.statusCode !== 200) {
          throw new Error(response.data.message)
      }

      return response.data?.data
    } catch(e) {
      console.error(`An error occurred in getAssistants: ${e}`)
    }
  }

  /**
   * @author Antonio Vazquez
   * @description event to deactivate botConfig
   * @date 10-11-2025
   * @returns {Object}
   * @memberof UserService
   */
  async deactivateAssistant(id, token) {
    try {
      let response = await axios.put(
        `${this.apiUrl}/deactivate-botconfig?id=${id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          }
        }
      )

      if (response.data.statusCode !== 200) {
          throw new Error(response.data.message)
      }

      return response.data?.data
    } catch(e) {
      console.error(`An error occurred in deactivateAssistant: ${e}`)
    }
  }

  /**
   * @author Antonio Vazquez
   * @description event to activate botConfig
   * @createdDate 19-12-25
   * @param {String} id bot id
   * @param {String} token auth token
   * @returns {Object}
   * @memberof UserService
   */
  async activateAssistant(id, token) {
    try {
      let response = await axios.put(
        `${this.apiUrl}/activate-botconfig?id=${id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`
          }
        }
      )

      if (response.data.statusCode !== 200) {
          throw new Error(response.data.message)
      }

      return response.data?.data
    } catch(e) {
      console.error(`An error occurred in activateAssistant: ${e}`)
    }
  }

  /**
   * @author Brayan Salas
   * @description Update default bot configuration for user
   * @date 01-07-2026
   * @param {String} botConfigId
   * @param {String} token
   * @returns {Object}
   * @memberof UserService
   */
  async updateDefaultBot(defaultBotConfigId, token) {
    let response = await axios.put(`${this.apiUrl}/update-user-profile`, { defaultBotConfigId }, {
      headers: {
        'Authorization': `Bearer ${token}`
      }
    })
    return response.data
  }

  /**
   * @author Jorge Perales
   * @description Get available assistants that can be assigned to a user (excluding already assigned and inactive)
   * @date 21-07-2026
   * @param {String} userId - User ID
   * @param {String} clientId - Client ID
   * @returns {Promise<Array>}
   */
  async getAvailableAssistants(userId, clientId) {
    const response = await axios.get(
      `${this.apiUrl}/users/${userId}/assistants/available?clientId=${clientId}`
    )
    return response.data.data || []
  }

  /**
   * @author Jorge Perales
   * @description Get assistants already assigned to a user
   * @date 21-07-2026
   * @param {String} userId - User ID
   * @returns {Promise<Array>}
   */
  async getAssignedAssistants(userId) {
    const response = await axios.get(
      `${this.apiUrl}/users/${userId}/assistants`
    )
    return response.data.data || []
  }

  /**
   * @author Jorge Perales
   * @description Assign an assistant to a user
   * @date 21-07-2026
   * @param {String} userId - User ID
   * @param {Array} assistantIds - rray of assistant IDs
   * @returns {Promise<Object>}
   */
  async assignAssistant(userId, assistantIds) {
    try {
      const response = await axios.put(
        `${this.apiUrl}/users/${userId}/assistants`,
        { 
          assistantIds: assistantIds  // Manda como array dentro de assistantIds
        }
      )
      console.log('updateUserAssistants response:', response.data)
      return response.data
    } catch (error) {
      console.error('updateUserAssistants error:', error.response?.data || error.message)
      throw error
    }
  }

  /**
   * @author Jorge Perales
   * @description Remove an assistant from a user
   * @date 21-07-2026
   * @param {String} userId - User ID
   * @param {String} assistantId - Assistant ID
   * @returns {Promise<Object>}
   */
  async unassignAssistant(userId, assistantId) {
    const response = await axios.delete(
      `${this.apiUrl}/users/${userId}/assistants/${assistantId}`
    )
    return response.data
  }
}

export { UserService as default };
